// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Component/img/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleDemoSty_loaderWrap__lLU8d {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
}

.ScheduleDemoSty_loader__1qEvu {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ScheduleDemoSty_spin__DnN8s 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes ScheduleDemoSty_spin__DnN8s {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ScheduleDemoSty_loadingText__tEGPQ {
  font-size: 1rem;
  color: #555;
}



.ScheduleDemoSty_demoWrap__HQYV7 {
  width: 100%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ScheduleDemoSty_container__elyYj {
  min-width: 500px;
  margin: 40px auto;
  padding: 30px;
  font-family: Arial, sans-serif;

  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 12px;
  padding: 50px 30px;
}

.ScheduleDemoSty_heading__68p47 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
}

.ScheduleDemoSty_form__ovjnk {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.ScheduleDemoSty_formGroup__xwf13 {
  margin-bottom: 24px;
  position: relative;
}
.ScheduleDemoSty_formGroup__xwf13 label {
  display: block;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #555;
}
.ScheduleDemoSty_inputWrapper__VqDzv {
  position: relative;
  display: flex;
  align-items: center;
}
.ScheduleDemoSty_container__elyYj .ScheduleDemoSty_input__rZswG {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  border: none;
  background: var(--seconadry-ic-bg);
  border-radius: 8px;
  color: var(--text-color);
  padding-right: 50px;
  outline: none;
}
.ScheduleDemoSty_inputWrapper__VqDzv ::placeholder {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
}
.ScheduleDemoSty_inputWrapper__VqDzv input:focus {
  border: 1px solid var(--seconadry-color);
  color: var(--dark-heading-text);
}
.ScheduleDemoSty_inputWrapper__VqDzv input:active {
  border: 1px solid var(--seconadry-color);
  color: var(--dark-heading-text);
}
.ScheduleDemoSty_inputIcon__1hN2e {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-color);
  font-size: 24px;
}
input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  opacity: 0;
  display: none;
  -webkit-appearance: none;
}
.ScheduleDemoSty_button__17\\+wj {
  width: 100%;
  height: 58px;
  margin-top: 36px;
  background-color: var(--primary);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}


@media (max-width: 768px) {
  .ScheduleDemoSty_container__elyYj {
    min-width: unset;
    width: 90%;
    padding: 30px 20px;
  }

  .ScheduleDemoSty_heading__68p47 {
    font-size: 20px;
  }

  .ScheduleDemoSty_formGroup__xwf13 label {
    font-size: 14px;
  }

  .ScheduleDemoSty_container__elyYj .ScheduleDemoSty_input__rZswG {
    padding: 14px;
    font-size: 14px;
  }

  .ScheduleDemoSty_inputWrapper__VqDzv ::placeholder {
    font-size: 14px;
  }

  .ScheduleDemoSty_inputIcon__1hN2e {
    font-size: 20px;
  }

  .ScheduleDemoSty_button__17\\+wj {
    height: 50px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  html,
  body {
    overflow: hidden;
    height: 100%;
    touch-action: none;
  }
  .ScheduleDemoSty_container__elyYj {
    width: 95%;
    padding: 20px 15px;
  }

  .ScheduleDemoSty_heading__68p47 {
    font-size: 18px;
  }

  .ScheduleDemoSty_form__ovjnk {
    gap: 12px;
  }

  .ScheduleDemoSty_formGroup__xwf13 label {
    font-size: 13px;
  }

  .ScheduleDemoSty_container__elyYj .ScheduleDemoSty_input__rZswG {
    padding: 12px;
    font-size: 13px;
  }

  .ScheduleDemoSty_button__17\\+wj {
    height: 48px;
    font-size: 14px;
  }

  .ScheduleDemoSty_inputIcon__1hN2e {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/ScheduleDemoSty.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2DAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,yDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;;EAE9B,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".loaderWrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  text-align: center;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loadingText {\n  font-size: 1rem;\n  color: #555;\n}\n\n\n\n.demoWrap {\n  width: 100%;\n  height: 100vh;\n  background-image: url(\"../Component/img/loginbg.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.container {\n  min-width: 500px;\n  margin: 40px auto;\n  padding: 30px;\n  font-family: Arial, sans-serif;\n\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 12px;\n  padding: 50px 30px;\n}\n\n.heading {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.formGroup {\n  margin-bottom: 24px;\n  position: relative;\n}\n.formGroup label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #555;\n}\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.container .input {\n  width: 100%;\n  padding: 16px;\n  font-weight: 600;\n  border: none;\n  background: var(--seconadry-ic-bg);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding-right: 50px;\n  outline: none;\n}\n.inputWrapper ::placeholder {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-color);\n}\n.inputWrapper input:focus {\n  border: 1px solid var(--seconadry-color);\n  color: var(--dark-heading-text);\n}\n.inputWrapper input:active {\n  border: 1px solid var(--seconadry-color);\n  color: var(--dark-heading-text);\n}\n.inputIcon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-color);\n  font-size: 24px;\n}\ninput[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  display: none;\n  -webkit-appearance: none;\n}\n.button {\n  width: 100%;\n  height: 58px;\n  margin-top: 36px;\n  background-color: var(--primary);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n\n@media (max-width: 768px) {\n  .container {\n    min-width: unset;\n    width: 90%;\n    padding: 30px 20px;\n  }\n\n  .heading {\n    font-size: 20px;\n  }\n\n  .formGroup label {\n    font-size: 14px;\n  }\n\n  .container .input {\n    padding: 14px;\n    font-size: 14px;\n  }\n\n  .inputWrapper ::placeholder {\n    font-size: 14px;\n  }\n\n  .inputIcon {\n    font-size: 20px;\n  }\n\n  .button {\n    height: 50px;\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  html,\n  body {\n    overflow: hidden;\n    height: 100%;\n    touch-action: none;\n  }\n  .container {\n    width: 95%;\n    padding: 20px 15px;\n  }\n\n  .heading {\n    font-size: 18px;\n  }\n\n  .form {\n    gap: 12px;\n  }\n\n  .formGroup label {\n    font-size: 13px;\n  }\n\n  .container .input {\n    padding: 12px;\n    font-size: 13px;\n  }\n\n  .button {\n    height: 48px;\n    font-size: 14px;\n  }\n\n  .inputIcon {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrap": `ScheduleDemoSty_loaderWrap__lLU8d`,
	"loader": `ScheduleDemoSty_loader__1qEvu`,
	"spin": `ScheduleDemoSty_spin__DnN8s`,
	"loadingText": `ScheduleDemoSty_loadingText__tEGPQ`,
	"demoWrap": `ScheduleDemoSty_demoWrap__HQYV7`,
	"container": `ScheduleDemoSty_container__elyYj`,
	"heading": `ScheduleDemoSty_heading__68p47`,
	"form": `ScheduleDemoSty_form__ovjnk`,
	"formGroup": `ScheduleDemoSty_formGroup__xwf13`,
	"inputWrapper": `ScheduleDemoSty_inputWrapper__VqDzv`,
	"input": `ScheduleDemoSty_input__rZswG`,
	"inputIcon": `ScheduleDemoSty_inputIcon__1hN2e`,
	"button": `ScheduleDemoSty_button__17+wj`
};
export default ___CSS_LOADER_EXPORT___;
